<template>
    <Lightbox
        :visible="$props.toggler"
        :imgs="$props.images"
        :index="$props.index"
        @hide="closeViewer"
        @on-index-change="recreateDownloadButton"
        moveDisabled
        rotateDisabled
    ></Lightbox>
</template>

<script>
import Lightbox from 'vue-easy-lightbox';

export default {
    name: 'ImageViewer',
    components: {Lightbox},
    props: ['images', 'toggler', 'index'],
    data() {
        return {};
    },
    watch: {
        '$props.toggler': {
            handler: function (newVal) {
                if (newVal) {
                    this.recreateDownloadButton();
                }
            }
        }
    },
    methods: {
        recreateDownloadButton() {
            setTimeout(() => {
                const lbImgWrapperElement = document.querySelector('.vel-img-wrapper');

                if (lbImgWrapperElement) {
                    const oldDownloadButton = document.querySelector('.lightbox-download-button');
                    if (oldDownloadButton) {
                        lbImgWrapperElement.removeChild(oldDownloadButton);
                    }
                    const downloadButton = document.createElement('div');
                    downloadButton.className = 'lightbox-download-button';
                    downloadButton.title = 'Download';
                    downloadButton.style.height = '30px';
                    downloadButton.style.width = '30px';
                    downloadButton.style.backgroundColor = '#b6b6b6';
                    downloadButton.style.color = '#3d3d3d';
                    downloadButton.style.textAlign = 'center';
                    downloadButton.style.position = 'absolute';
                    downloadButton.style.bottom = '10px';
                    downloadButton.style.right = '10px';
                    downloadButton.style.cursor = 'pointer';
                    downloadButton.style.padding = '5px';
                    downloadButton.style.borderRadius = '5px';

                    const icon = document.createElement('i');
                    icon.className = 'fas fa-download';
                    downloadButton.appendChild(icon);

                    lbImgWrapperElement.appendChild(downloadButton);
                }
            }, 500);
        },
        downloadImage() {
            const imageToDownload = document.querySelector('.vel-img');
            if (imageToDownload) {
                if (imageToDownload.src) {
                    window.open(imageToDownload.src);
                }
            }
        },
        closeViewer() {
            this.$emit('closeViewer');
        }
    },
    mounted() {
        this.recreateDownloadButton();
    }
};
</script>

<style scoped></style>
